import { _API_URL } from "@/actions/constants";
import Reload from "@/models/gateway/reload.model";
import { BaseService, type PrefixType } from "./base.service";

/**
 * Service để xử lý các tương tác với server BE (Stream trong phiên họp).
 */
class ReloadService extends BaseService<Reload, string> {
  constructor(prefix: PrefixType = 'allow', suffix: string = '') {
    super(Reload, prefix, suffix);
  }

  /** Kết nối sse stream (REST) */
  static connect = (_body?: any): Promise<any> => {
    const sv = new ReloadService('allow', '/GetUnReloadV2');
    return sv.getCustom({});
  };

  /** Tạo SSE EventSource connection */
  static connectSSE = (key?: string): EventSource => {
    const sv = new ReloadService('allow', '/GetUnReloadV2');
    const params = key ? `?meetingId=${encodeURIComponent(key)}` : '';
    return new EventSource(`${_API_URL}${sv.endpoint}${params}`, { withCredentials: true });
  };

  /** Đánh dấu tất cả đã xem */
  static viewAll = (body?: any): Promise<any> => {
    const sv = new ReloadService('allow', '/ViewAll');
    return sv.create(body ?? {});
  };

  /** Đánh dấu reload item đã xem */
  static viewReload = (body?: any): Promise<any> => {
    const sv = new ReloadService('allow', '/ViewReload');
    return sv.create(body ?? {});
  };

  /** Xóa thông báo theo key */
  static deleteOldReloads = (body: any): Promise<any> => {
    const sv = new ReloadService('allow', '/DeleteOldReloads');
    return sv.deleteWithBody(body);
  };
}

export default ReloadService;
